import {observable, action, runInAction} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {objToValueObj, setStore} from '../../../../utils/Utils'
import {message} from "antd";

class FaultCaseCarseriesMaintenanceStore {

    @observable list //车系列表
    @observable page //车系分页
    @observable loading
    @observable brands //品牌
    @observable carSeries //车系
    @observable modalSelect //新增车系模态框
    @observable brandId //品牌ID
    @observable carSeriesId //车系ID
    @observable carSerie
    @observable upLoading //上传图标
    @observable imageUrl //上传图标
    @observable editBoxModal //上传图标模态框


    constructor() {
        this.list = []
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.loading = false
        this.brands = {
            list: [],
            selected: ''
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.modalSelect = false
        this.brandId = []
        this.carSeriesId = []
        this.carSerie = {}
        this.upLoading=false
        this.imageUrl=''
        this.editBoxModal=false
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /** 初始化页面 **/
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/queryListByPage`, {
            page: page - 1,
            carseriesName: '',
            size: this.page.pageSize
        })
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content || []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**初始化品牌下拉框**/
    @action
    initBrands = async () => {
        runInAction(() => {
            this.loading = true
            this.brands = {
                list: [],
                selected: ''
            }
            this.modalSelect = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/get/all`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.brands.list = Array.isArray(res) ? res : []
            let brand = this.brands.list.find((item) => item.defaultName === '')
            let value = brand && brand.defaultName
            this.initCarseries(value)
        })
    }

    /**初始化车系下拉框**/
    @action
    initCarseries = async (value) => {
        let brand = this.brands.list.find((item) => item.defaultName === value)
        let ids = brand && brand.id
        if (!ids) {
            return
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/carsystem/ids`, {ids})
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carSeries.list = Array.isArray(res) ? res : []
            this.brand = brand
        })
    }

    @action
    selectCarseries = (value) => {
        let carSerie = this.carSeries.list.find((item) => item.defaultName === value)
        this.carSerie = carSerie
    }

    /**选中品牌**/
    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    /**选中车系**/
    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    /** 取消编辑 **/
    @action.bound
    cancelEdit () {
        this.loading = false
        this.modalSelect = false
    }

    /**新增品牌车系**/
    @action
    saveCatalog = async () => {
        const data = {
            'carseriesName': this.carSerie.defaultName,
            'carseriesCode': this.carSerie.carSeriesCode,
            'carseriesImage': this.carSerie.icon,
            'brandId': this.brand.id,
            'brandName': this.brand.defaultName,
            'carseriesId': this.carSerie.id,
            'state': 0,
            'rank': this.carSerie.rank
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/add`, data)
        runInAction(() => {
            if(res && res.status === 1){
                message.success('新增成功')
            } else {
                message.warning("不允许添加重复数据")
            }
            this.loading = false
            this.modalSelect = false
        })
        this.initListPage(this.page)
    }

    /** 新增修改开启模态框 **/
    @action
    showEditBox = (record) => {
        runInAction(() => {
            this.editRecord = record
            this.loading = true
            this.editBoxModal = true
            this.imageUrl=record.carseriesImage
            this.loading = false
        })
    }

    //修改保存图片
    saveImgBox=async()=>{
        console.log(JSON.parse(JSON.stringify(this.editRecord.carseriesImage)))
        if(!this.editRecord.carseriesImage ||!this.imageUrl){
            return message.warning('请上传车系图片')
        }else{
            let obj = {...this.editRecord,carseriesImage:this.imageUrl}
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/update`,obj)
            if (res && res.status === 1) {
                message.success(res.data)
                runInAction(()=>{
                    this.editBoxModal=false
                })
            }
            await this.initListPage(this.page)
        }
    }

    /**
     * 删除车系记录
     */
    @action
    deleteByCarseriesId = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/delById/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        await this.initListPage(this.page)
    }

    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
        if (info.file.status === 'uploading') {
            runInAction(() => {
                this.upLoading = true
            })
            return
        }
        if (info.file.status === 'done') {
            runInAction(() => {
                this.imageUrl =info.file.response
                this.upLoading = false
            })
            return
        }
        if (info.file.status === 'error') {
            runInAction(() => {
                this.upLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

}
export default new FaultCaseCarseriesMaintenanceStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/FaultDiagnosis/FaultCaseCarseriesMaintenance/store.js